module.exports = require("./../../_gen/starling/text/BitmapChar");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/BitmapChar.js
// module id = 223
// module chunks = 0